import dotPropImmutable from 'dot-prop-immutable';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'api/models';
import { SPRINT_IN_TEMPLATE_DURATION_MULTIPLE } from 'components/organisms/sprint-planning/constants';
import { PhaseEntityType, converToEntityId } from 'data/projects/phase-entity';
import { insert } from '../utils';
export const sprintSlice = {
    createProjectTemplateSprint: (state, { payload })=>{
        const { projectPhaseId, sprint, insertAt } = payload;
        const parentProjectPhase = dotPropImmutable.get(state, `data.${state.activeId}.projectPhases.${projectPhaseId}`, {});
        const sprintPayload = {
            ...sprint,
            projectPhase: {
                projectPhaseId
            },
            subTasks: [],
            startDay: parentProjectPhase.startDay || 1,
            duration: SPRINT_IN_TEMPLATE_DURATION_MULTIPLE,
            private: parentProjectPhase.private,
            isNewEntity: true
        };
        const sprintPath = `data.${state.activeId}.sprints.${sprintPayload.sprintId}`;
        const sprintResult = dotPropImmutable.set(state, sprintPath, sprintPayload);
        const sprintRefPath = `data.${state.activeId}.projectPhases.${projectPhaseId}.sprints`;
        const entityOrder = dotPropImmutable.get(sprintResult, `data.${state.activeId}.projectPhases.${projectPhaseId}.entityOrder`, []);
        let result;
        if (!insertAt) {
            const sprintOrderResult = dotPropImmutable.merge(sprintResult, sprintRefPath, [
                sprintPayload.sprintId
            ]);
            result = dotPropImmutable.set(sprintOrderResult, `data.${state.activeId}.projectPhases.${projectPhaseId}.entityOrder`, [
                ...entityOrder,
                converToEntityId(sprint.sprintId, PhaseEntityType.Sprint)
            ]);
        } else {
            const sprintIds = dotPropImmutable.get(sprintResult, sprintRefPath, []);
            const insertAtIndex = entityOrder.findIndex((id)=>id === insertAt.id);
            const modifiedSprintIds = insert(sprintIds, insertAtIndex + insertAt.dir, sprint.sprintId);
            const sprintOrderResult = dotPropImmutable.set(sprintResult, sprintRefPath, modifiedSprintIds);
            const modifiedEntityOrder = insert(entityOrder, insertAtIndex + insertAt.dir, converToEntityId(sprint.sprintId, PhaseEntityType.Sprint));
            result = dotPropImmutable.set(sprintOrderResult, `data.${state.activeId}.projectPhases.${projectPhaseId}.entityOrder`, modifiedEntityOrder);
        }
        return result;
    },
    updateProjectTemplateSprint: (state, { payload: { sprint, isNew } })=>{
        return dotPropImmutable.merge(state, `data.${state.activeId}.sprints.${sprint.sprintId}`, {
            ...sprint,
            ...{
                isNew
            }
        });
    },
    updateProjectTemplateSprints: (state, { payload })=>{
        const updatedSprints = {};
        payload === null || payload === void 0 ? void 0 : payload.forEach(({ id, startDay, duration })=>{
            const sprint = state.data[`${state.activeId}`].sprints[id];
            const updates = {};
            if (startDay) {
                updates.startDay = startDay;
            }
            if (duration) {
                updates.duration = duration;
            }
            updatedSprints[id] = {
                ...sprint,
                ...updates
            };
        });
        return dotPropImmutable.merge(state, `data.${state.activeId}.sprints`, updatedSprints);
    },
    makeDateShiftsForSprints: (state, { payload })=>{
        const updatedSprints = {};
        payload === null || payload === void 0 ? void 0 : payload.forEach((sprintUpdates)=>{
            const { sprintId, startDate, dueDate } = sprintUpdates;
            const sprint = state.data[`${state.activeId}`].sprints[sprintId];
            const currentStartDate = moment().add(sprint.startDay, 'day').startOf('day').format(DEFAULT_DATE_FORMAT);
            const currentDueDate = moment().add(sprint.startDay + sprint.duration - 1, 'day').endOf('day').format(DEFAULT_DATE_FORMAT);
            updatedSprints[sprintId] = {
                ...sprint,
                startDay: startDate ? Math.round(Math.abs(moment().startOf('day').diff(moment(startDate), 'day', true))) : sprint.startDay,
                duration: startDate || dueDate ? Math.round(moment(dueDate || currentDueDate).endOf('day').diff(moment(startDate || currentStartDate).startOf('day'), 'day', true)) : sprint.duration
            };
        });
        return dotPropImmutable.merge(state, `data.${state.activeId}.sprints`, updatedSprints);
    },
    deleteProjectTemplateSprint: (state, { payload })=>{
        const path = `data.${state.activeId}.sprints.${payload.sprintId}`;
        const sprintResult = dotPropImmutable.get(state, path);
        const sprintIds = state.data[state.activeId].projectPhases[sprintResult.projectPhase.projectPhaseId].sprints.filter((id)=>id !== payload.sprintId);
        const result = dotPropImmutable.set(state, `data.${state.activeId}.projectPhases.${sprintResult.projectPhase.projectPhaseId}.sprints`, sprintIds);
        return result;
    }
};
